exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".connection-status-container {\n  position: fixed;\n  right: 20px;\n  top: 20px;\n  z-index: 1001; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/connection-status/connection-status.scss
// module id = 940
// module chunks = 1